import axios from '@/axios/axios2'

// 发票详情接口
export const fetchInvoiceInfo = params =>
  axios.post('/invoice/getInvoiceInfo', params)
